import { RouterLink } from '@/components'
import { routes } from '@/router'
import { SwapVert } from '@mui/icons-material'
import { useMediaQuery, Theme, Box, Card, Typography } from '@mui/material'

export function MonthlyDocuments() {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))

  if (isMobile) {
    return (
      <RouterLink to={routes.monthlyDocuments}>
        <Card>
          <Box textAlign="right">
            <SwapVert sx={{ color: 'secondary.main', fontSize: 32 }} />
          </Box>
          <Typography fontSize={18}>
            Movimento <br /> mensal
          </Typography>
        </Card>
      </RouterLink>
    )
  }

  return (
    <Card>
      <Typography fontSize={20} mb={2}>
        Movimento mensal
      </Typography>

      <Typography color="textDisabled" py={3} textAlign="center">
        Você não possui pendências
      </Typography>
    </Card>
  )
}
